// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingSpinnerWrapper--AI7Yw {
  height: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/GroupDetailedInfo/partials/DriversOfChanges/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".loadingSpinnerWrapper {\n  height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingSpinnerWrapper": `loadingSpinnerWrapper--AI7Yw`
};
export default ___CSS_LOADER_EXPORT___;
